import {
  APagination,
  BookPaperItem,
  MicroPaperItem,
  NoResult,
  PicturePaperItem
} from '@/components'
import LessInfo from '@/components/LessInfo'
import { Component, Mixins, Watch } from 'vue-property-decorator'
import ScrollToTop from '../../mixins/scrollToTop'
import { getMicroCourseList, getPictureBookList, paperList } from '../../model/api'

@Component({
  components: {
    BookPaperItem,
    NoResult,
    APagination,
    LessInfo,
    PicturePaperItem,
    MicroPaperItem
  }
})
export default class PaperList extends Mixins(ScrollToTop) {
  // 课件
  public visible = false
  public currentTitle = ''
  public contentData = []
  public page = 1
  public sortType = 1 // 1 更新时间  2 收藏数目 默认1
  public total = 0
  public page_total = 0
  // 公用
  public bookCatalogId = 0
  public loading = false
  public perPage = 10
  public checkUserOk = false // 判断usertoken接口调用成功标识
  // 绘本
  public pictureCurrentTitle = ''
  public picturePage = 1
  public sortOrder = 'asc'
  public pictureSortType = 1 // 默认1
  public pictureTotal = 0
  public pictureContentData = []
  public picturePageTotal = 0
  // 微课
  public microCurrentTitle = ''
  public microPage = 1
  public microSortType = 1 // 默认1
  public microTotal = 0
  public microContentData = []
  public microPageTotal = 0

  // computed
  private get userInfo() {
    return this.$store.state.user_info
  }
  public get subjectId() {
    return this.$store.state.subject.value
  }
  private get book() {
    return this.$store.state.question.book
  }
  // sourceType
  private get sourceType() {
    return this.$store.state.question.sourceType || 1
  }
  // courseType
  private get courseType() {
    return this.$store.state.question.courseType
  }
  private get catalog() {
    return this.$store.state.question.catalog
  }
  public get userName() {
    return this.$store.state.user_info && this.$store.state.user_info.nickname
  }
  private get platformlogin() {
    return this.$store.state.platformlogin
  }
  // watch
  @Watch('sourceType')
  public onSourceTypeChange(val) {
    if (val === 1) {
      this.page = 1
      this.getList()
    }
    if (val === 2) {
      this.microPage = 1
      this.getMicroCourseList()
    }
    if (val === 3) {
      this.picturePage = 1
      this.getPictureBookList()
    }
  }
  @Watch('courseType')
  public onCourseTypeChange(val) {
    this.getMicroCourseList()
  }
  @Watch('platformlogin', { deep: true })
  public onPlatformlogin() {
    this.checkUserOk = true
  }
  @Watch('subjectId')
  public onSubjectIdChange(val) {
    if ([101, 102, 103, 201, 202, 203, 204, 205, 302, 304, 305].includes(val)) {
      window.location.reload()
    } else {
      window.location.href = '/'
    }
  }
  @Watch('currentTitle')
  public onCurrentTitleChange(val) {
    if (val === '') {
      this.page = 1
      this.getList()
    }
  }
  @Watch('microCurrentTitle')
  public onMicroCurrentTitleChange(val) {
    if (val === '') {
      this.page = 1
      this.getMicroCourseList()
    }
  }
  @Watch('pictureCurrentTitle')
  public onPictureCurrentTitleChange(val) {
    if (val === '') {
      this.picturePage = 1
      this.getPictureBookList()
    }
  }
  @Watch('userInfo', { deep: true })
  public onUserChange(val, old) {
    if (old && val && val.nickname === old.nickname) return
    if (val && val.nickname) {
      location.reload()
    }
  }
  @Watch('book')
  public onBookChange(val) {
    if (!val) return
    this.bookCatalogId = val
    if (this.sourceType === 1) {
      this.page = 1
      this.getList()
    }
    if (this.sourceType === 2) {
      this.microPage = 1
      this.getMicroCourseList()
    }
    if (this.sourceType === 3) {
      this.picturePage = 1
      this.getPictureBookList()
    }
  }
  @Watch('catalog')
  public onCatalogChange(val) {
    if (!val) return
    this.bookCatalogId = val
    if (this.sourceType === 1) {
      this.page = 1
      this.getList()
    }
    if (this.sourceType === 2) {
      this.microPage = 1
      this.getMicroCourseList()
    }
    if (this.sourceType === 3) {
      this.picturePage = 1
      this.getPictureBookList()
    }
  }
  // mounted
  public mounted() {
    this.bookCatalogId = this.book
    if ([101, 102, 103, 201, 202, 203].includes(this.subjectId)) {
      this.getList()
    } else {
      this.getMicroCourseList()
    }
  }
  // reset
  public reset() {
    this.$store.commit('SET_RESET', true)
    this.currentTitle = ''
    this.contentData = []
    this.page = 1
    this.sortType = 1
    this.getList()
  }
  // picReset
  public picReset() {
    this.$store.commit('SET_RESET', true)
    this.pictureCurrentTitle = ''
    this.pictureContentData = []
    this.picturePage = 1
    this.pictureSortType = 1
    this.getPictureBookList()
  }
  // micReset
  public micReset() {
    this.$store.commit('SET_RESET', true)
    this.microCurrentTitle = ''
    this.microContentData = []
    this.microPage = 1
    this.microSortType = 1
    this.getMicroCourseList()
  }
  // onSortOrder
  public onSortOrder(val) {
    this.picturePage = 1
    this.sortOrder = val
    this.getPictureBookList()
  }
  // onSearch
  public onSearch() {
    // 课件搜索
    window['sensors'].track('TIKU_search', {
      moduleName: '课件',
      keyword: this.currentTitle
    })
    this.page = 1
    this.getList()
  }
  // microOnSearch
  public microOnSearch() {
    // 微课搜索
    window['sensors'].track('TIKU_search', {
      moduleName: '微课',
      keyword: this.microCurrentTitle
    })
    this.microPage = 1
    this.getMicroCourseList()
  }
  // pictureOnSearch
  public pictureOnSearch() {
    // 绘本搜索
    window['sensors'].track('TIKU_search', {
      moduleName: '绘本',
      keyword: this.pictureCurrentTitle
    })
    this.picturePage = 1
    this.getPictureBookList()
  }
  // onPageChange
  public onPageChange(val) {
    this.page = val
    this.getList()
    this.scrollTo(0)
  }
  // pictureOnPageChange
  public pictureOnPageChange(val) {
    this.picturePage = val
    this.getPictureBookList()
    this.scrollTo(0)
  }
  // microOnPageChange
  public microOnPageChange(val) {
    this.microPage = val
    this.getMicroCourseList()
    this.scrollTo(0)
  }
  // onClickRanger
  public onClickRanger(val, type) {
    this[type] = val
    if (type === 'sortType') {
      this.page = 1
      this.getList()
      window['sensors'].track('TIKU_afterFilter_clk', {
        moduleName: '课件',
        filter: val === 1 ? '更新日期' : '收藏数'
      })
    }
    if (type === 'microSortType') {
      this.microPage = 1
      this.getMicroCourseList()
      const lib = {
        1: '综合排序',
        2: '更新日期',
        3: '热度',
        4: '收藏数'
      }
      window['sensors'].track('TIKU_afterFilter_clk', {
        moduleName: '微课',
        filter: lib[val]
      })
    }
    if (type === 'pictureSortType') {
      this.sortOrder = val === 1 ? 'asc' : 'desc'
      this.picturePage = 1
      this.getPictureBookList()
      const lib = {
        1: '综合排序',
        2: '蓝思值',
        3: '热度',
        4: '收藏数'
      }
      window['sensors'].track('TIKU_afterFilter_clk', {
        moduleName: '绘本',
        filter: lib[val]
      })
    }
  }
   // changeFavoriteList
  public changeFavoriteList() {
    this.getList()
  }
  // changeMicFavoriteList
  public changeMicFavoriteList() {
    this.getMicroCourseList()
  }
  // changePicFavoriteList
  public changePicFavoriteList() {
    this.getPictureBookList()
  }
  // 获取列表
  public async getList() {
    if (!this.subjectId) {
      return
    }
    // if (!this.checkUserOk) return
    let obj = {
      subject_id: this.subjectId,
      visible_type: 1,
      book_catalog_id: this.bookCatalogId,
      name: this.currentTitle,
      page: this.page,
      sort_type: this.sortType}
    if (!this.loading) {
      this.loading = true
    }
    try {
      const { data, total }: any = await paperList(obj)
      if (this.loading) {
        this.loading = false
      }
      if (data && data.length > 0) {
        this.contentData = data
        this.total = total
        if (this.total >= 100 * this.perPage) {
          this.page_total = 100 * this.perPage
        } else {
          this.page_total = this.total
        }
      } else {
        this.contentData = []
        this.total = 0
      }
    } catch (e) {
      if (this.loading) {
        this.loading = false
      }
      this.contentData = []
      this.total = 0
    }
  }
  // 获取绘本列表
  public async getPictureBookList() {
    let obj = {
      book_catalog_id: this.bookCatalogId,
      sort_order: this.sortOrder,
      content: this.pictureCurrentTitle,
      page: this.picturePage,
      sort_type: this.pictureSortType}
    if (!this.loading) {
      this.loading = true
    }
    try {
      const { data, total }: any = await getPictureBookList(obj)
      if (this.loading) {
        this.loading = false
      }
      if (data && data.length > 0) {
        this.pictureContentData = data
        this.pictureTotal = total
        if (this.pictureTotal >= 100 * this.perPage) {
          this.picturePageTotal = 100 * this.perPage
        } else {
          this.picturePageTotal = this.pictureTotal
        }
      } else {
        this.pictureContentData = []
        this.pictureTotal = 0
      }
    } catch (e) {
      if (this.loading) {
        this.loading = false
      }
      this.pictureContentData = []
      this.pictureTotal = 0
    }
  }
  // 获取微课列表
  public async getMicroCourseList() {
    let obj = {
      subject_id: this.subjectId,
      book_catalog_id: this.bookCatalogId,
      name: this.microCurrentTitle,
      course_type: this.courseType,
      page: this.microPage,
      sort_type: this.microSortType
    }
    if (!this.loading) {
      this.loading = true
    }
    try {
      const { data, total }: any = await getMicroCourseList(obj)
      if (this.loading) {
        this.loading = false
      }
      if (data && data.length > 0) {
        this.microContentData = data
        this.microTotal = total
        if (this.microTotal >= 100 * this.perPage) {
          this.microPageTotal = 100 * this.perPage
        } else {
          this.microPageTotal = this.microTotal
        }
      } else {
        this.microContentData = []
        this.microTotal = 0
      }
    } catch (e) {
      if (this.loading) {
        this.loading = false
      }
      this.microContentData = []
      this.microTotal = 0
    }
  }
}